export class FRegExpMgr {
  public static resourceNameOptimized(name: string): string {
    // /^(?!.*(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#|([\p{Emoji_Presentation}\u200D]+(?:\p{Emoji}\uFE0F)?|(?:\p{Emoji}\uFE0F)))).{1,60}$/gu
    return name.replace(new RegExp(/(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#|([\p{Emoji_Presentation}\u200D]+(?:\p{Emoji}\uFE0F)?|(?:\p{Emoji}\uFE0F)))+/u, 'g'), '_');
  }

  public static removeExtension(filename: string) {
    // 使用正则表达式匹配并替换掉扩展名部分（从最后一个点号及之后的内容）
    return filename.replace(new RegExp(/\.[^.]*$/), '');
  }
}
